@if (user()) {
    <div class="text-[var(--color-text-strong)]">
        <div>
            <h1 class="h-[55px] font-shBreeHeadline text-[var(--color-text-strong)]">
                <span class="font-shBreeHeadline text-[rgb(var(--ui-2))]">{{ 'home-dashboard.ema' | translate }}</span>
                {{ 'home-dashboard.title' | translate }}
            </h1>
            <span class="text-[rgb(var(--ui-5))]">{{ 'home-dashboard.description' | translate }}</span>
        </div>
        <div
            class="grid w-full grid-cols-1 gap-5 pt-3 sm:grid-cols-2"
            [class]="delegatesEnabled ? 'lg:grid-cols-3' : 'lg:grid-cols-2'"
            [style.max-width]="delegatesEnabled ? '1000px' : '670px'"
        >
            @for (tile of visibleTiles(); track tile.link) {
                <app-dashboard-tile [item]="tile" />
            }
        </div>
    </div>
}
